import { HTMLAttributes } from 'react'
import { useTheme } from '@mui/material'

import classes from './index.styles'

/**
 * Blurred scrim for use as the `backdrop` slot of MUI Dialog and Drawer components
 */
const BlurSkrim = ({ style, ...props }: HTMLAttributes<HTMLDivElement>) => {
  const theme = useTheme()

  return <div {...props} style={{ ...style, ...classes.skrim(theme) }} />
}

export default BlurSkrim
